<template>
	 <div>
		<b-col cols="12">
			<h2>{{ $t('patient-panel.habits-challenges')}}</h2>
		</b-col>
		<b-row class="neu-cards-ctn landing-cnt mt-5" cols="1" cols-xl="4">
			<PatientPanelServiceBlock id="goals" visible :title="$t('patient-panel.my-goals')" img="/static-appopensalud/img/icons/morillas-svg-icons/primary/goals.svg" :action="() => $helpers.goToHabits()"/>
			<PatientPanelServiceBlock id="micro-habits" visible :title="$t('patient-panel.habits-that-care')" img="/static-appopensalud/img/icons/morillas-svg-icons/primary/habitos.png" iconSize="40" :action="() => $router.push('/patient/microhabits')"/>
		</b-row>
	</div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock.vue'

export default {
	components: {
		PatientPanelServiceBlock
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/GoalsHabitsPanelMenu.vue